import { InjectionToken, Signal } from '@angular/core';

export const USER_VIEW_TOKEN = new InjectionToken<'learner' | 'instructor'>('EnrollmentDetailUserView');

export const ENROLLMENT_USER_ID_TOKEN = new InjectionToken<Signal<number | undefined>>('EnrollmentUserID');

/** Override which user (learner/instructor) is displayed on lesson cards. When not provided, defaults to the inverse of userView. */
export const ENROLLMENT_DISPLAYED_USER_TOKEN = new InjectionToken<'learner' | 'instructor'>('EnrollmentDisplayedUser');
